import { EmailAddress } from '../value-objects/EmailAddress';
import { PhoneNumber } from '../value-objects/PhoneNumber';
import { AddressBookError } from '../errors/AddressBookError';

export class AddressBookEntry {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly email?: string,
    public readonly phone?: string
  ) {}

  static create(name: string, email?: string, phone?: string): AddressBookEntry {
    const trimmedName = name?.trim() ?? '';
    if (!trimmedName) {
      throw AddressBookError.entryNameRequired();
    }

    const normalizedEmail = email && email.trim() ? new EmailAddress(email.trim()).getValue() : undefined;
    const normalizedPhone = phone && phone.trim() ? new PhoneNumber(phone.trim()).getValue() : undefined;

    if (!normalizedEmail && !normalizedPhone) {
      throw AddressBookError.entryContactRequired();
    }

    return new AddressBookEntry(crypto.randomUUID(), trimmedName, normalizedEmail, normalizedPhone);
  }

  static fromPersistence(id: string, name: string, email?: string, phone?: string): AddressBookEntry {
    return new AddressBookEntry(id, name, email, phone);
  }

  update(name?: string, email?: string, phone?: string): AddressBookEntry {
    const nextName = name !== undefined ? name.trim() : this.name;
    if (!nextName) {
      throw AddressBookError.entryNameRequired();
    }

    const nextEmail = email !== undefined
      ? (email.trim() ? new EmailAddress(email.trim()).getValue() : undefined)
      : this.email;
    const nextPhone = phone !== undefined
      ? (phone.trim() ? new PhoneNumber(phone.trim()).getValue() : undefined)
      : this.phone;

    if (!nextEmail && !nextPhone) {
      throw AddressBookError.entryContactRequired();
    }

    return new AddressBookEntry(this.id, nextName, nextEmail, nextPhone);
  }
}
